import { render, staticRenderFns } from "./QnaEnrollment.vue?vue&type=template&id=dd08ebe4&"
import script from "./QnaEnrollment.vue?vue&type=script&lang=js&"
export * from "./QnaEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports